import Decimal from 'decimal.js';
import { StagesValueType } from '~/models';
export const computeTotalSumExceedsRate = (stages, valueType, totalRate)=>{
    const totalSum = stages.reduce((acc, stage)=>acc.plus(stage.value), new Decimal(0));
    return totalSum.gt(valueType === StagesValueType.Amount ? totalRate : new Decimal(100));
};
export const getStageHelperText = (param)=>{
    let { stage, isLast, valueType, totalRate, totalSumExceedsRate, texts } = param;
    const isPercent = valueType === StagesValueType.Percent;
    const isDollars = valueType === StagesValueType.Amount;
    if (isPercent && stage.value.gte(100)) return texts.validation.exceedsPercent();
    if (isDollars && stage.value.gt(totalRate)) return texts.validation.exceedsServiceTotal();
    if (isPercent && !isLast && totalSumExceedsRate) return texts.validation.exceedsPercent();
    if (isDollars && !isLast && totalSumExceedsRate) return texts.validation.exceedsServiceTotal();
    if (isLast && stage.value.eq(0)) return texts.validation.lastPaymentCannotBeEmpty();
    if (stage.value.eq(0)) return texts.validation.insertAmount();
    return undefined;
};
